// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable react/style-prop-object */ /* eslint-disable max-len */
import React from 'react';
import { H1 } from '../../components/Custom/Typography/Typography';
import { getPrivacyPolicyPath } from '../../constants/routes';

const CookiePolicyEn: React.FC = () => (
  <div className="px-10 py-10">
    <p align="center">
      <H1><strong>COOKIE NOTICE</strong></H1>
    </p>
    <p align="center">
      <strong>Effective date: </strong>
      <span>11 December 2025</span>
    </p>
    <br />
    <p align="justify">
      This Cookie Notice describes how we, PT Multifinance Anak Bangsa (hereinafter referred to as “
      <strong>We</strong>
      ”, “
      <strong>Us</strong>
      ”, or “
      <strong>Our</strong>
      ”), utilize tracking technologies on our websites and/or applications (collectively referred to as “
      <strong>Platforms</strong>
      ”). This Cookie Notice applies to all visitors and users (“
      <strong>You</strong>
      ”) of the Platforms.
    </p>
    <p>We set out below information about:</p>
    <ul className="list-disc ml-10">
      <li>Cookies;</li>
      <li>How We use cookies; and</li>
      <li>How to contact Us.</li>
    </ul>
    <br />
    <p><strong>1. COOKIES</strong></p>
    <p align="justify">
      A cookie is a small text file sent from a website to Your computer or mobile device, where it is stored by Your web browser. Cookies help websites remember information about You, making it easier for You to revisit the site.
      {' '}
    </p>
    <p align="justify">
      We only use cookies that are strictly required for the operation or functionality of Our Platforms, hence there is no need for them to be adjusted or turned off.
    </p>
    <p align="justify">
      It is important to understand that the information and/or data stored by cookies is located on your web browser or device. If desired, you can also choose to delete cookies stored on your web browser or device through Your browser settings. The majority of today’s browsers will enable you to delete your cookies by going to the browser’s settings and choosing clear cookies options.
    </p>
    <br />
    <p><strong>2. HOW WE USE COOKIES </strong></p>
    <p align="justify">
      We only use cookies that are strictly necessary for the operation or functionality of the Platforms.
    </p>
    <br />
    <p><strong><u>Strictly Necessary Cookies</u></strong></p>
    <p align="justify">
      Strictly necessary cookies are essential for the core features of Our Platforms to function properly. These cookies are always set to “Active” as they are required to provide the services, applications, and functionalities You request. Below is the detailed list of the strictly necessary cookies We use on Our Platforms and the purposes for which each cookie is enabled:
    </p>
    <br />
    <table className="w-full border-collapse border border-gray-400">
      <thead>
        <tr className="bg-gray-100">
          <th className="border border-gray-400 px-4 py-2 text-left">Cookie Name</th>
          <th className="border border-gray-400 px-4 py-2 text-left">Host</th>
          <th className="border border-gray-400 px-4 py-2 text-left">Expiration</th>
          <th className="border border-gray-400 px-4 py-2 text-left">Type of Service</th>
          <th className="border border-gray-400 px-4 py-2 text-left">Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-gray-400 px-4 py-2">acw_tcw</td>
          <td className="border border-gray-400 px-4 py-2">merchantlending.mab.co.id</td>
          <td className="border border-gray-400 px-4 py-2">Persistent</td>
          <td className="border border-gray-400 px-4 py-2">First-party</td>
          <td className="border border-gray-400 px-4 py-2">Used to protect the website from suspicious activity and cyber attacks.</td>
        </tr>
      </tbody>
    </table>
    <br />
    <p><strong>3. HOW TO CONTACT US</strong></p>
    <p align="justify">
      Any changes to this Cookie Notice will be posted here. Please check back this page regularly to stay informed of any updates. If You have any questions about this Cookie Notice, please contact Us through our contact information mentioned in our
      &nbsp;
      <a
        href={getPrivacyPolicyPath('en')}
        className="underline text-blue-600 hover:text-blue-800"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Notice
      </a>
      &nbsp;.
    </p>
  </div>
);

export default CookiePolicyEn;